import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";
import { DynamicSubscriptionButton } from "scmp-app/lib/sdk/dynamics";

export const Container = styled(ResponsiveContainer)``;

export const StyledDynamicSubscriptionButton = styled(DynamicSubscriptionButton)`
  padding: 4px;

  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.064px;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 7px;
    padding-inline: 8px;

    font-size: 14px;
    line-height: 16px;
    letter-spacing: normal;
  }
`;
